<template>
  <div class="aliService">
    <div @click="showChat">
      <slot />
    </div>
  </div>
</template>

<script>
import { getRunTime } from '../../../tools/utils'
import { getRunningEnv } from '../../../tools/getPlatform'
import Bridge from '../../../lib/Bridge'
import createHttp from '../../../tools/axios.js'
let historyScrollTop = 0

const openWebView = (options, isApp) => {
  options = {
    isCurrentPageOpen: 0,
    ...options
  }

  if (isApp) {
    const myBridge = new Bridge()
    myBridge.call('openWebView', options)
  } else {
    window.location.href = options.url
  }
}

export default {
  props: {
    // true: 弹窗模式下，打开弹窗禁止下拉刷新，关闭弹窗允许下拉刷新
    // false: 要是页面本来就禁掉了下拉刷新，就设置成false，不然关闭弹窗页面会放开限制允许下拉
    controlRefresh: {
      type: Boolean,
      default: true
    },
    // 合从初始化自定义参数
    initHecongConfig: {
      type: Object,
      default() {
        return {}
      }
    },
    // 合从用户上报用户信息自定义参数
    assignHeCongCustomer: {
      type: Object,
      default: () => ({})
    },
    // 弹窗模式下，打开合从是否需要登录
    needLogin: {
      type: Boolean,
      default: true
    },
    // 是否打开一个新页面而不是弹窗
    blank: {
      type: Boolean,
      default: true
    },
    // 合从渠道ID
    channelId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      user: '',
      _http: null,
      myBridge: null,
      isInApp: false
    }
  },
  mounted() {
    const { isYixinliApp, isZiXunApp } = this.$platform
    this.isInApp = isYixinliApp || isZiXunApp
    this._http = createHttp()
    this.myBridge = new Bridge()

    if (!this.blank) {
      this.init()
    }
  },
  beforeDestroy() {
    if (this.aihecongFIXiOsScrollBugTimer) {
      clearInterval(this.aihecongFIXiOsScrollBugTimer)
    }
    this.hideBubble()
  },
  methods: {
    // 弹窗模式下 - 初始化合从
    async init() {
      await this.getUserInfo() // 先获取用户信息
      if (!window._AIHECONG) {
        await this.getAIHECONG()
      }
    },
    // 弹窗模式下 - 下载合从sdk文件
    getAIHECONG() {
      ;(function (d, w, c) {
        if (w[c]) return
        var s = d.createElement('script')
        w[c] = function () {
          ;(w[c].z = w[c].z || []).push(arguments)
        }
        s.async = true
        s.src = 'https://static.ahc.ink/hecong.js'
        if (d.head) d.head.appendChild(s)
      })(document, window, '_AIHECONG')

      window._AIHECONG(
        'ini',
        Object.assign(
          {
            channelId: this.channelId,
            autoInvi: false, // 禁止对话邀请
            button: false //去除聊天按钮
          },
          this.initHecongConfig
        )
      )

      this.uploadUserInfo()
      window._AIHECONG('visibleCallback', isVisible => {
        if (isVisible === 'hide') {
          clearInterval(this.aihecongFIXiOsScrollBugTimer)
          window.scrollTo(0, historyScrollTop || 0)

          if (this.controlRefresh && this.isInApp) {
            this.myBridge.call('isPullRefreshEnable', { enable: 1 })
          }
        }
      })
    },
    // 弹窗模式下 - 上报用户信息给合从
    uploadUserInfo() {
      if (this.user.nickname) {
        // 设置用户信息
        window._AIHECONG('customer', {
          head: this.user.avatar || '', //该字段可以将顾客头像同步过来
          名称: this.user.nickname || '',
          ID: this.user.id || '',
          ...this.assignHeCongCustomer
        })
      } else if (Object.keys(this.assignHeCongCustomer).length) {
        window._AIHECONG('customer', this.assignHeCongCustomer)
      }
    },
    // 弹窗模式下 - 获取用户信息
    async getUserInfo() {
      const s = getRunTime('//m.xinli001.com')
      return this._http
        .get(`//${s}/ajax/get-user-header`)
        .then(res => {
          const { code, data } = res.data
          if (code === 0) {
            this.user = data.user
          }
        })
    },
    // 弹窗模式下 - 跳登录
    toLogin() {
      let runtime = getRunTime('//m.xinli001.com')
      if (this.isInApp) {
        window.location.href = 'yixinli://open_user_login'
      } else {
        const loginHref = `${runtime}/account/login?next=${encodeURIComponent(
          window.location.href
        )}`
        window.location.href = loginHref
      }
    },
    // _blank: true   打开新页面
    // _blank: false  打开弹窗
    showChat() {
      this.$emit('open')

      // 如果是直接打开新页面
      // 咨询首页安卓手机合从弹窗会有输入框遮挡和上传图片卡死的问题，要直接新开页面
      if (this.blank) {
        const protocol = window.location.protocol
        const { env } = getRunningEnv()
        const LAPP = protocol + `//lapp${env ? '-' + env : ''}.xinli001.com`
        let heCongUrl = `${LAPP}/html/consultService/index.html`
        heCongUrl += `?channelId=${ this.channelId || '' }`
        if (this.assignHeCongCustomer && Object.keys(this.assignHeCongCustomer).length) {
          heCongUrl += `&assignHeCongCustomer=${encodeURIComponent(JSON.stringify(this.assignHeCongCustomer))}`
        }
        return openWebView(
          {
            url: heCongUrl
          },
          this.isInApp
        )
      } else {
        if (!this.channelId) return
        this.init().then(() => {
          if ((!this.user || Array.isArray(this.user)) && this.needLogin) {
            return this.toLogin()
          }
          if (!window._AIHECONG) return

          historyScrollTop =
            document.documentElement.scrollTop ||
            window.pageYOffset ||
            document.body.scrollTop
          if (this.controlRefresh && this.isInApp) {
            this.myBridge.call('isPullRefreshEnable', { enable: 0 })
          }

          try {
            if (this.$platform.isiPhone && this.isInApp) {
              let iosV = parseInt(
                navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1],
                10
              )
              if (iosV >= 12) {
                let scrollAdded = false
                this.aihecongFIXiOsScrollBugTimer = setInterval(() => {
                  window.scrollTo(
                    0,
                    document.body.clientHeight + (scrollAdded ? 0.1 : -0.1)
                  )
                  scrollAdded = !scrollAdded
                }, 1000)
              }
            }
          } catch (e) {
            console.log(e)
          }
          window._AIHECONG('showChat')
        })
      }
    },
    // 供外部使用
    openDialog() {
      this.showChat()
    },
    // 隐藏引导气泡，没有相关api支持
    hideBubble() {
      const closeBuddleDom = document.querySelector(
        '#_aihecong_chat_container_start ._aihecong_chat_autoinvi_close'
      )

      if (closeBuddleDom) {
        closeBuddleDom.click()
      }
    }
  }
}
</script>

<style lang="scss">
#_aihecong_chat_container_body
  ._aihecong_chat_autoinvi_img._aihecong_chat_autoinvi_mobile
  ._aihecong_chat_autoinvi_body
  img {
  width: auto;
}

#_aihecong_chat_container_body {
  z-index: 999 !important;
  ._aihecong_chat_autoinvi_body {
    box-shadow: none !important;
  }
}
</style>
